<template>
  <v-container>
    <v-card>
      <v-card-text style="padding: 0px">
        <template>
          <v-toolbar color="primary" light>
            <v-toolbar-title class="white--text">Categories</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
              <v-btn
                color="white"
                flat
                @click="
                  dialog = true;
                  resetForm();
                "
                :disabled="!vid"
                dark
                >Add New</v-btn
              >
            </v-toolbar-items>
          </v-toolbar>
        </template>
        <div>
          <v-toolbar flat color="white" dense style="margin-bottom: 0px">
            <v-btn color="success" small @click="loadCategories()"
              ><v-icon>mdi-refresh</v-icon> Refresh</v-btn
            >
            <v-spacer></v-spacer>
            <div style="width: 200px">
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </div>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="categories"
            :search="search"
            :loading="true"
            item-key="id"
            dense
            class="elevation-1"
          >
            <v-progress-linear
              slot="progress"
              color="blue"
              indeterminate
            ></v-progress-linear>
            <template slot="headerCell" slot-scope="{ header }">
              <div
                class="subheading font-weight-light text-primary text--darken-3"
                v-text="header.text"
              ></div>
              <div
                class="font-weight-light text--darken-4"
                v-text="header.desc"
              ></div>
            </template>

            <template slot="items" slot-scope="props">
              <td>
                <img
                  :src="props.item.image"
                  style="width: 50px; height: 50px; object-fit: cover"
                />
              </td>
              <td>{{ props.item.name }}</td>
              <td class="text-xs-center text-no-wrap">
                <v-btn
                  small
                  color="red"
                  @click="
                    confirm = true;
                    deletedId = props.item.id;
                  "
                  dark
                  ><v-icon small>mdi-delete</v-icon></v-btn
                ><v-btn
                  small
                  color="blue"
                  @click="editCategory(props.item)"
                  dark
                  ><v-icon small>mdi-lead-pencil</v-icon></v-btn
                >
              </td>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">New Category</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex
                  xs6
                  sm6
                  md6
                  align-center
                  text-xs-center
                  style="position: relative"
                >
                  <img
                    v-if="category.image != ''"
                    @click="$refs.image.click()"
                    :src="category.image"
                    style="width: 150px; height: 150px; object-fit: cover"
                  />
                  <img
                    v-else
                    src="img/image.jpg"
                    @click="$refs.image.click()"
                    style="width: 150px; height: 150px; object-fit: cover"
                  />
                  <v-flex
                    v-if="uploading"
                    d-flex
                    align-center
                    align-content-center
                    style="
                      position: absolute;
                      left: 50%;
                      margin-left: -75px;
                      top: 0;
                      width: 150px;
                      height: 150px;
                      background: rgba(0, 0, 0, 0.5);
                    "
                  >
                    <v-progress-circular
                      :value="progress"
                      color="primary lighten-2"
                      size="75"
                    ></v-progress-circular>
                  </v-flex>
                  <v-text-field
                    @click="$refs.image.click()"
                    color="green"
                    placeholder="Select Image"
                    readonly
                    :value="file && file.name"
                    :rules="rules.file"
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="image"
                    accept="image/*"
                    @change="pickFile($event)"
                    required
                  />
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    label="Name*"
                    :rules="rules.name"
                    required
                    v-model="category.name"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            small
            outline
            @click.native="
              dialog = false;
              resetForm();
            "
            >Close</v-btn
          >
          <v-btn
            color="primary darken-1 white--text"
            small
            :disabled="!valid && uploading"
            @click.native="addCategory()"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog1" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Update Category</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid1">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex
                  xs6
                  sm6
                  md6
                  align-center
                  text-xs-center
                  style="position: relative"
                >
                  <img
                    v-if="category.image != ''"
                    @click="$refs.image.click()"
                    :src="category.image"
                    style="width: 150px; height: 150px; object-fit: cover"
                  />
                  <img
                    v-else
                    src="img/image.jpg"
                    @click="$refs.image.click()"
                    style="width: 150px; height: 150px; object-fit: cover"
                  />
                  <v-flex
                    v-if="uploading"
                    d-flex
                    align-center
                    align-content-center
                    style="
                      position: absolute;
                      left: 50%;
                      margin-left: -75px;
                      top: 0;
                      width: 150px;
                      height: 150px;
                      background: rgba(0, 0, 0, 0.5);
                    "
                  >
                    <v-progress-circular
                      :value="progress"
                      color="primary lighten-2"
                      size="75"
                    ></v-progress-circular>
                  </v-flex>
                  <v-text-field
                    @click="$refs.image.click()"
                    color="green"
                    placeholder="Select Image"
                    readonly
                    :value="file && file.name"
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="image"
                    accept="image/*"
                    @change="pickFile($event)"
                    required
                  />
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    label="Name*"
                    :rules="rules.name"
                    required
                    v-model="category.name"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            small
            outline
            @click.native="
              dialog1 = false;
              resetForm();
            "
            >Close</v-btn
          >
          <v-btn
            color="primary darken-1 white--text"
            small
            :disabled="!valid1 || uploading"
            @click.native="updateCategory()"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" max-width="400px">
      <v-card>
        <v-card-title class="red--text">
          <h3>Warning !!</h3>
        </v-card-title>
        <v-card-text>
          Error: Something went wrong... Please try again.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="blue" flat @click="dialog2 = false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirm" width="400">
      <v-card style="width: 100%">
        <v-card-title class="red--text"> Warning !! </v-card-title>
        <v-card-text class="pt-0">
          All Products In Category Will Be Deleted
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" dark outline @click="confirm = false"
            >Cancel</v-btn
          >
          <v-btn small dark color="primary" @click="deleteCategory()"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script type="text/javascript">
import api from '@/api';
export default {
  data() {
    return {
      search: '',
      uploading: false,
      progress: 0,
      categories: [],
      headers: [],
      deletedId: '',
      dialog: false,
      category: {
        image: '',
        name: '',
      },
      rules: {
        name: [v => /^(?!\s*$).+/.test(v) || 'Name is required'],
        file: [v => !!v || 'file is required'],
      },
      dialog2: false,
      dialog1: false,
      valid: false,
      valid1: false,
      confirm: false,
      file: null,
    };
  },
  watch: {
    vid() {
      this.loadCategories();
    },
  },
  computed: {
    vid() {
      return this.$store.state.vid;
    },
  },
  methods: {
    loadCategories() {
      let loader = this.$loading.show();
      api
        .get('categories')
        .then(r => {
          this.categories = r.data;
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.loadCategories();
            }
          }
        });
    },
    pickFile(e) {
      if (e.target.files.length > 0) {
        this.file = e.target.files[0];
        this.category.image = URL.createObjectURL(this.file);

        this.uploadImage(this.file);
      }
    },
    uploadImage(file) {
      this.uploading = true;
      let formData = new FormData();
      formData.append('image', file);
      api
        .post('upload/file', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: progressEvent =>
            (this.progress = progressEvent.total),
        })
        .then(r => {
          this.category.image = r.data.file_url;
          this.uploading = false;
        })
        .catch(() => {
          this.dialog2 = true;
        });
    },
    addCategory() {
      if (this.valid) {
        let loader = this.$loading.show();
        api
          .post('categories', {
            image: this.category.image,
            name: this.category.name,
          })
          .then(r => {
            loader.hide();
            this.loadCategories();
            this.dialog = false;
            this.resetForm();
          })
          .catch(err => {
            loader.hide();
            this.dialog2 = true;
          });
      }
    },
    editCategory(c) {
      this.category.id = c.id;
      this.category.name = c.name;
      this.category.image = c.image;
      this.file = '';
      this.valid1 = false;
      this.dialog1 = true;
    },
    updateCategory() {
      if (this.valid1) {
        let loader = this.$loading.show();
        api
          .put('categories/' + this.category.id, {
            image: this.category.image,
            name: this.category.name,
          })
          .then(r => {
            loader.hide();
            this.loadCategories();
            this.dialog1 = false;
            this.resetForm();
          })
          .catch(err => {
            loader.hide();
            this.dialog2 = true;
          });
      }
    },
    deleteCategory(e) {
      this.confirm = false;
      let loader = this.$loading.show();
      api.delete('categories/' + this.deletedId).then(r => {
        loader.hide();

        this.loadCategories();
      });
    },
    resetForm() {
      this.category.name = '';
      this.category.image = '';
      this.file = null;
      this.$refs.image.value = '';
    },
  },
  created() {
    if (this.vid)
      api
        .get('categories/')
        .then(r => {
          this.categories = r.data;
        })
        .catch(async err => {
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.loadCategories();
            }
          }
        });
    this.headers = [
      {
        sortable: false,
        text: 'Image',
        value: 'image',
        align: 'center',
      },
      {
        sortable: false,
        text: 'Name',
        value: 'name',
        align: 'center',
      },
      {
        sortable: false,
        text: 'Actions',
        align: 'center',
      },
    ];
  },
};
</script>
